import { Grid } from "@mui/material";
import React from "react";
import "./connectwallet.css";

function ConnectWallet() {
  return (
    <div className="Main_div">
      <Grid container justifyContent="center">
        <Grid item xs={11} sm={8} md={11.5} lg={10}>
          <h1 className="heading_wallet">connect wallet</h1>
          <p className="wallet_para">
            Connect with one of available wallet providers or create a new
            wallet.
          </p>
          <div className="seprator"></div>

          {/* Nested Grid */}
          <Grid container justifyContent="center">
            <Grid item lg={6}>
              <Grid container>
                <Grid item xs={12} lg={12}>
                  <div className="wallet_card_i">
                    <img
                      src="./Assets/meta.png"
                      alt=""
                      className="wallet_img"
                    />
                    <span className="meta_text">metamask</span>
                  </div>
                </Grid>
                <Grid item xs={12} lg={12}>
                  <div className="wallet_card_i">
                    <img
                      src="./Assets/Connec.png"
                      alt=""
                      className="wallet_img_2"
                    />
                    <span className="meta_text">Wallet connect</span>
                  </div>
                </Grid>
                <Grid item xs={12} lg={12}>
                  <div className="wallet_card_i">
                    <img
                      src="./Assets/image 5.png"
                      alt=""
                      className="wallet_img_2"
                    />
                    <span className="meta_text"> trust Wallet </span>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default ConnectWallet;
